import { useDispatch } from 'react-redux';
import { appActions } from '../../../../store/modules/app';
import { getKeyByValue } from '../../../../lib/common';
import { Attachment, AttachmentForVideoUploadResponse } from '../types';
import { ATTACHMENT_TYPE_NUM } from '../constants';

interface IUseVideoUploadProps {
  uploadSuccessAttachment: (data: Attachment, index: number) => void;
}
const useVideoUpload = (props: IUseVideoUploadProps) => {
  const { uploadSuccessAttachment } = props;
  const dispatch = useDispatch();

  const videoUploadSuccess = ({ url, width, height, type }: AttachmentForVideoUploadResponse, index: number) => {
    const data = {
      url: url,
      width: width,
      height: height,
      type: getKeyByValue(ATTACHMENT_TYPE_NUM, type),
    };
    uploadSuccessAttachment(data, index);
  };

  const uploadVideo = (index: number, data?: Attachment) => {
    dispatch(
      appActions.appToggleModal({
        name: 'videoUploadModal',
        data: {
          addVideo: (_data: AttachmentForVideoUploadResponse) => videoUploadSuccess(_data, index),
          ...data,
        },
      }),
    );
  };

  return { uploadVideo };
};

export default useVideoUpload;
